import { createRouter, createWebHistory } from 'vue-router';
import NewsListPage from "./NewsListPage.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.news-list-page', NewsListPage, {
  jsonProps: ['newsTypes', 'topics', 'years'],
  beforeMount: (el, props) => {
  },
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});